import { WrenchIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

export function UnderMaintenance() {
  const intl = useIntl();

  return (
    <div className="flex min-h-screen w-full flex-col">
      <div className="flex h-[90%] w-full flex-col items-center justify-center">
        <WrenchIcon size={60} alt="Maintenance" />
        <h3 className="pb-2 text-[20px] font-bold">
          {intl.formatMessage({ id: "maintenance.title" })}
        </h3>
        <span>
          {intl.formatMessage({ id: "maintenance.makingImprovements" })}
        </span>
        <span>{intl.formatMessage({ id: "maintenance.checkBackSoon" })}</span>
      </div>
    </div>
  );
}
